<template>
  <div>
    <!-- banner -->
    <!-- <Banner></Banner> -->
    <base-banner
			:title="banner.title"
			:caption="banner.caption"
			:backgroundImage="banner.image"
			:titleColor="banner.titleColor"
			:captionColor="banner.captionColor"
			:backgroundColor="banner.backgroundColor"
			:buttons="banner.buttons"
		/>

    <!-- steps section -->
    <Steps :steps="steps"></Steps>

    <!-- video section -->
    <Video></Video>

    <!-- plan section -->
    <Plan :plans="plans"></Plan>
  </div>
</template>

<script>
  import Repository from "@/api/repositories";
  // import { RESELLER_EVENT_BUS } from "./js/ResellerEventBus";

  const ResellersApi = Repository.get("resellers");
  const ResellerShopBannersApi = Repository.get("resellerShopBanners");
  const ResellerShopPlansApi = Repository.get("resellerShopPlans");
  const ResellerShopStepsApi = Repository.get("resellerShopSteps");

  export default {
    name: 'ResellerHome',

    components: {
      Steps: () => import('@/components/reseller/Steps.vue'),
      Video: () => import('@/components/reseller/Video.vue'),
      Plan: () => import('@/components/reseller/Plan.vue'),
      // ResellerLayout: () => import('./ResellerLayout.vue')
    },
    
    data: () => ({
      resellerId: null,
      reseller: {},
      banner: [],
      plans: [],
      steps: []
    }),

    watch: {
      resellerId: {
        handler: function(value) {
          if (value) {
            this.getShopBanners();
            this.getShopPlans();
            this.getShopSteps();
          }
        },
        immediate: true
      }
    },

    async mounted() {
      this.getReseller();
    },

    methods: {
      async getReseller() {
        let slug = this.$route.params.slug;

        await ResellersApi
          .getDetailsViaSlug(slug)
          .then(response => {
            let {
              data: {
                data : item
              }
            } = response;

            // console.log({ item });

            this.resellerId = item.id;
            this.reseller = item;

            // RESELLER_EVENT_BUS.reseller = item;
          })
          .catch(error => {
            console.log({ error });
          })
      },
			async getShopBanners() {
				try {
          let params = {
            reseller_id: this.resellerId,
            order_by: "ASC"
          };

          const { data } = await ResellerShopBannersApi.get({ params });
					
					if (data) {
						let apiData = data.data[0];

						let buttons = apiData.buttons.map(button => {
							return {
								name: button.label,
								icon: button.image,
								link: button.redirect,
								color: JSON.parse(button.styling).color
							}
						});

						let banner = {
							buttons: buttons,
							image: apiData.background_image.main,
							caption: apiData.caption,
							title: apiData.title,
							titleColor: apiData.styles.titleColor,
							captionColor: apiData.styles.captionColor,
							backgroundColor: apiData.styles.backgroundColor
						}

						this.banner = banner;
					}

					// console.log('[shop-banner]', data, this.banner);
				}
				catch(error) {
					console.log(error);
				}
      },
      async getShopPlans() {
        let params = {
          reseller_id: this.resellerId,
          order_by: "ASC"
        };

        await ResellerShopPlansApi
          .get({ params })
          .then(response => {
            let {
              data: { data: items }
            } = response;

            this.plans = items.map(item => {
              // console.log({ item }, "shop")
              return {
                id: item.id,
                name: item.name,
                amount: item.price,
                description: item.description,
                no_key_generate: item.no_key_generate,
                details: item.other_details,
                discount: item.discount
              };
            });
          })
          .catch(error => {
            console.log({ error });

            this.plans = [];
          })
      },
      async getShopSteps() {
        let params = {
          reseller_id: this.resellerId,
          order_by: "ASC"
        };

        await ResellerShopStepsApi
          .get({ params })
          .then(response => {
            let {
              data: { data: items }
            } = response;

            this.steps = items.map(item => {
              return {
                id: item.id,
                image: item.background_image
                  ? item.background_image.main
                  : null,
                title: item.title,
                caption: item.caption,
              };
            });
          })
          .catch(error => {
            console.log({ error });

            this.steps = [];
          })
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>